import React, { useEffect, useState } from 'react';
import { toLocalDateString, toLocalDate, fromLocalDate } from 'utils/localTime';
import { listAlertConfigurations } from 'services/alertConfigurationsService';
import { getGasConsumption } from 'services/gasConsumptionService';

// Define the props type
interface DailyThresholdProps {
}

const DailyThreshold: React.FC<DailyThresholdProps> = () => {
  const [currentData, setCurrentData] = useState<{ baseMdq: string; baseMdqDays: string; peak: string, colorClass: string, time: string; } | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      const [year, monthIndex, day, hours] = toLocalDate(new Date());
      
      const alertConfigsData = await listAlertConfigurations();
      
      // first with data.type of base_rate is the base rate
      const baseMdqConfig = alertConfigsData.find(config => config.data.type === 'base_rate');
      if (baseMdqConfig) {
        const end = fromLocalDate(year, monthIndex, day, 0, 0, 0);
        const start = new Date(end.getTime() - baseMdqConfig.data.days * 24 * 3600 * 1000);

        const {gas_consumption_projection, gas_consumption} =
        await getGasConsumption(start, end, 'd');
        // gas_consumption has { gas_consumption: number, time: Date }
        // get peak value
        const peak = gas_consumption.reduce((a:number, v:any) => Math.max(a, v.gas_consumption), 0);
        // if peak is greater than base rate,  color it red, otherwise green
        const colorClass = peak > baseMdqConfig.data.threshold ? 'text-red-500  ml-2 mr-2' : 'text-green-300  ml-2 mr-2';
        setCurrentData({
          baseMdq: `${baseMdqConfig.data.threshold}`,
          baseMdqDays: `${baseMdqConfig.data.days}`,
          peak: `${peak}`,
          colorClass,
          time: toLocalDateString(start),
        });
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {currentData && (
        <>
          <span>
            <span className="text-gray-300 mr-2">MDQ ({currentData.baseMdqDays} days)</span>
            PEAK:<span className={currentData.colorClass}>{Number(currentData.peak).toFixed(2)}</span>
            BASE:<span className="text-blue-300 ml-2 mr-2">{currentData.baseMdq}</span>
          </span>
        </>
      )}
    </>
  );
}

export default DailyThreshold;
